var MediatorTrigger = {
  instance: function () {
    if (!MediatorTrigger.instance) {
      MediatorTrigger.instance = this;
    }
    return MediatorTrigger.instance;
  },

  formList: null,
  formManagement: null,
  formSelectIndicator: null,
  formValueLimit: null,
  formReliability: null,
  formAverageValue: null,
  rtaTriggers: null,

  notify(sender, event) {
    switch (event) {
      case "initTriggerList":
        this.formList = sender
        break;
      case "initTriggerManager":
        this.formManagement = sender
        break;

      case "initSelectIndicator":
        this.formSelectIndicator = sender
        break;

      case "initTriggerValueLimit":
        this.formValueLimit = sender
        break;

      case "initTriggerReliability":
        this.formReliability = sender
        break;

      case "initTriggerAverageValue":
        this.formAverageValue = sender
        break;

      case "initRtaTriggers":
        this.rtaTriggers = sender;
        break

      case "editTriggerInList":
        editTriggerFromList(sender)
        break;

      case "setVLV":
      case "setVFR":
      case "setVLT":
      case "setALT":
      case "setALD":
      case "setATS":
      case "setADI":
      case "setATM":
      case "setVMH":
      case "setVMW":
      case "setVMD":
      case "setVMT":
      case "setAMH":
      case "setRFG":
      case "setRFI":
      case "setRSG":
      case "setVMW_RTA":
      case "setASW_RTA":
        let key = event.replace("set", "")
        if (this.formManagement != null) {
          this.formManagement.triggerSet.setContent(sender, key)
        } else {
          this.rtaTriggers.triggerSet.setContent(sender, key)
        }
        break;

      case "checkLoadTriger":
        checkLoadTriger(sender)
        break;
    }
  }
}

function editTriggerFromList(item) {
  if (MediatorTrigger.formSelectIndicator == null || MediatorTrigger.formManagement == null) {
    // modo só-RTA
    const map = MediatorTrigger.rtaTriggers.triggerSet.getTriggers(item);
    setForms(map, item);                                    //  <-- passa item
  } else {
    // Seleciona indicador
    MediatorTrigger.formSelectIndicator.loadForm(item.key);

    // Seleciona gatilhos
    const map = MediatorTrigger.formManagement.triggerSet.getTriggers(item);
    MediatorTrigger.formManagement.isEditing = true;

    // Carrega parâmetros influenciadores do primeiro gatilho encontrado
    const matchedTrigger = MediatorTrigger.formManagement.triggerSet.databaseTriggers.find(t => t.key === item.key);
    MediatorTrigger.formManagement.currentInfluencingParameters =
      matchedTrigger && matchedTrigger.influencingParameters
        ? matchedTrigger.influencingParameters
        : [];

    setForms(map, item);                                    //  <-- passa item
  }
}

function setForms(map, item) {
  // Se não encontrou, zera tudo
  if (!map) return;

  if (MediatorTrigger.formManagement != null)
    MediatorTrigger.formManagement.triggerIsSelected = true;

  // reseta formulários individuais
  MediatorTrigger.formValueLimit.resetForm();
  MediatorTrigger.formReliability.resetForm();
  MediatorTrigger.formAverageValue.resetForm();

  if (MediatorTrigger.rtaTriggers != null)
    MediatorTrigger.rtaTriggers.cleanFields(false);

  /* ---- Gatilhos de limite ----------------------------------------- */
  const VLV = map.get("VLV");
  const VFR = map.get("VFR");
  const VLT = map.get("VLT");

  /* ---- Gatilhos de aderência -------------------------------------- */
  const ALT = map.get("ALT");
  const ALD = map.get("ALD");
  const ATS = map.get("ATS");
  const ADI = map.get("ADI");
  const ATM = map.get("ATM");

  /* ---- Gatilhos de média ------------------------------------------ */
  const VMD = map.get("VMD");
  const VMT = map.get("VMT");

  /* ---- Média de aderência ----------------------------------------- */
  const AMH = map.get("AMH");
  const VMH = map.get("VMH");
  const VMW = map.get("VMW");
  const VMW_RTA = map.get("VMW_RTA");
  const ASW_RTA = map.get("ASW_RTA");

  /* ---- RTA exclusivos --------------------------------------------- */
  const RFG = map.get("RFG");
  const RFI = map.get("RFI");
  const RSG = map.get("RSG");

  /* ---- Preenche formulários com delay para evitar overlap Vue ----- */
  setTimeout(() => {
    setTimeout(() => {
      MediatorTrigger.formValueLimit.loadForm({ VLV, VFR, VLT });
    }, 100);

    setTimeout(() => {
      MediatorTrigger.formReliability.loadForm({ ALT, ALD, ATS, ADI, ATM, ASW_RTA });
    }, 200);

    setTimeout(() => {
      MediatorTrigger.formAverageValue.loadForm({ VMD, VMT, AMH, VMH, VMW, VMW_RTA });
    }, 300);

    setTimeout(() => {
      // ---- INFO GERAIS (Processo / Produto / Equipamento) ------------
      MediatorTrigger.rtaTriggers.loadForm({
        RFG, RFI, RSG,
        processId:   item.processId   ?? MediatorTrigger.rtaTriggers.triggerProductions.processId,
        productId:   item.productId   ?? MediatorTrigger.rtaTriggers.triggerProductions.productId,
        equipmentId: item.equipmentId ?? MediatorTrigger.rtaTriggers.triggerProductions.equipmentId
      });

      // força os selects de “Informações Gerais” a exibirem o valor
      const tp = MediatorTrigger.rtaTriggers.triggerProductions || {};
      if (item.processId   != null) tp.processId   = item.processId;
      if (item.productId   != null) tp.productId   = item.productId;
      if (item.equipmentId != null) tp.equipmentId = item.equipmentId;
    }, 400);
  }, 200);
}


function checkLoadTriger(value) {
  let map = MediatorTrigger.formManagement.triggerSet.canLoadTriggers(value)
  if (map) {
    setForms(map)
    MediatorTrigger.formSelectIndicator.messageDataLoaded()
  } else {
    MediatorTrigger.formManagement.triggerIsSelected = false;
  }
}


export default MediatorTrigger